import styles from "./getHelp.module.scss";
import PropTypes from "prop-types";
import ConfirmModal from "../confirmModal/ConfirmModal";
import { useState } from "react";
import config from "../../../config/index";
import { imagePrefix, getCookieValue } from "../../../utils/helperServices";
import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData
} from "../../../services/analyticsUtag";

const GetHelp = (props) => {
  const env = config.env;
  const legacyEnv = config.envConfigs[env].legacyEnv;
  const [show, setShow] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const confirmLabel = "Call me back";
  const cancelLabel = "No, thanks";

  const handleCancel = () => {
    setShow(false);
    setShowBtn(true);
  };

  const showModal = () => {
    setShow(true);
    setShowBtn(false);

    AnalyticsLink({
      page_tool_event: "use",
      page_tool_name: `${
        AnalyticsGetUtagData(["page_name"]).page_name
      }: need some help?`,
      ...getUtagViewData(),
    });
  };

  const handleDismiss = () => {
    handleCancel();
    AnalyticsLink({
      page_tool_event: "use",
      page_tool_name: `${
        AnalyticsGetUtagData(["page_name"]).page_name
      }: dismiss`,
      ...getUtagViewData(),
    });
  };

  const handleConfirm = () => {
    handleCancel();

    AnalyticsLink({
      link_type: "o",
      link_name: `${
        AnalyticsGetUtagData(["page_name"]).page_name
      }: ${confirmLabel}`,
      ...getUtagViewData(),
    });
    
    const isMiniApp = getCookieValue("miniApp") === "true";
    let targetToOpen = isMiniApp ? "_self" : "_blank"
    
    window.open(
      `https://www${legacyEnv}.vodacom.co.za/shopping/forms/ecommerce?bucket=${props?.leadBucket}`,
      targetToOpen,
    );
  };

  const getUtagViewData = () => {
    return AnalyticsGetUtagData([
      "visitor_customer_id",
      "visitor_login_status",
      "visitor_subscription_type",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "page_site_section_lvl_4",
      "visitor_msisdn_hash",
      "page_name",
      "page_channel",
      "page_master_tab",
      "upgrade_eligibility_status",
      "upgrade_ineligible_reason",
      "upgrade_eligible_date",
      "upgrade_customer_type",
    ]);
  };

  return (
    <>
      <div
        className={`${props.stacked && styles.stick_to_bottom} ${styles.btn} ${props.className} ${
          showBtn ? styles["btn-view"] : ""
        }`}
        onClick={showModal}
        id="ecom-help-btn"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 35.8332C28.7445 35.8332 35.8334 28.7443 35.8334 19.9998C35.8334 11.2553 28.7445 4.1665 20 4.1665C11.2555 4.1665 4.16669 11.2553 4.16669 19.9998C4.16669 28.7443 11.2555 35.8332 20 35.8332Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 4.9667C11.6974 4.9667 4.9667 11.6974 4.9667 20C4.9667 28.3027 11.6974 35.0334 20 35.0334C28.3027 35.0334 35.0334 28.3027 35.0334 20C35.0334 11.6974 28.3027 4.9667 20 4.9667ZM3.3667 20C3.3667 10.8137 10.8137 3.3667 20 3.3667C29.1864 3.3667 36.6334 10.8137 36.6334 20C36.6334 29.1864 29.1864 36.6334 20 36.6334C10.8137 36.6334 3.3667 29.1864 3.3667 20Z"
            fill="white"
          />
          <path
            d="M15.8083 14.6439C15.8083 14.6439 16.377 11.6001 20 11.6168C23.6229 11.6334 24.8479 16.0793 22.9375 18.023C22.0833 18.8959 21.352 19.6147 20.8333 20.1189C20.5693 20.3799 20.3597 20.6907 20.2166 21.0333C20.0736 21.3759 19.9999 21.7434 20 22.1147V23.7251"
            stroke="url(#paint0_linear_12149:283893)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0001 28.7167C20.2118 28.7167 20.3834 28.5451 20.3834 28.3334C20.3834 28.1217 20.2118 27.95 20.0001 27.95C19.7883 27.95 19.6167 28.1217 19.6167 28.3334C19.6167 28.5451 19.7883 28.7167 20.0001 28.7167ZM18.7834 28.3334C18.7834 27.6614 19.3281 27.1167 20.0001 27.1167C20.672 27.1167 21.2167 27.6614 21.2167 28.3334C21.2167 29.0053 20.672 29.55 20.0001 29.55C19.3281 29.55 18.7834 29.0053 18.7834 28.3334Z"
            fill="url(#paint1_linear_12149:283893)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9999 28.9252C20.3267 28.9252 20.5916 28.6603 20.5916 28.3335C20.5916 28.0068 20.3267 27.7419 19.9999 27.7419C19.6732 27.7419 19.4083 28.0068 19.4083 28.3335C19.4083 28.6603 19.6732 28.9252 19.9999 28.9252ZM18.9916 28.3335C18.9916 27.7766 19.4431 27.3252 19.9999 27.3252C20.5568 27.3252 21.0083 27.7766 21.0083 28.3335C21.0083 28.8904 20.5568 29.3419 19.9999 29.3419C19.4431 29.3419 18.9916 28.8904 18.9916 28.3335Z"
            fill="url(#paint2_linear_12149:283893)"
          />
          <path
            d="M20 29.583C20.6904 29.583 21.25 29.0234 21.25 28.333C21.25 27.6427 20.6904 27.083 20 27.083C19.3096 27.083 18.75 27.6427 18.75 28.333C18.75 29.0234 19.3096 29.583 20 29.583Z"
            fill="url(#paint3_linear_12149:283893)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 27.983C19.8067 27.983 19.65 28.1397 19.65 28.333C19.65 28.5263 19.8067 28.683 20 28.683C20.1933 28.683 20.35 28.5263 20.35 28.333C20.35 28.1397 20.1933 27.983 20 27.983ZM21.25 28.333C21.25 29.0234 20.6904 29.583 20 29.583C19.3096 29.583 18.75 29.0234 18.75 28.333C18.75 27.6427 19.3096 27.083 20 27.083C20.6904 27.083 21.25 27.6427 21.25 28.333Z"
            fill="url(#paint4_linear_12149:283893)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_12149:283893"
              x1="16.834"
              y1="22.1773"
              x2="26.8532"
              y2="15.5376"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E0000" />
              <stop offset="1" stopColor="#F30000" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_12149:283893"
              x1="19.0944"
              y1="29.239"
              x2="21.2808"
              y2="27.0527"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E0000" />
              <stop offset="1" stopColor="#F30000" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_12149:283893"
              x1="19.2494"
              y1="29.0841"
              x2="21.0613"
              y2="27.2721"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E0000" />
              <stop offset="1" stopColor="#F30000" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_12149:283893"
              x1="19.0696"
              y1="29.2634"
              x2="21.3158"
              y2="27.0172"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E0000" />
              <stop offset="1" stopColor="#F30000" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_12149:283893"
              x1="19.0696"
              y1="29.2634"
              x2="21.3158"
              y2="27.0172"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8E0000" />
              <stop offset="1" stopColor="#F30000" />
            </linearGradient>
          </defs>
        </svg>
        <div className={styles.txt}>
          Need&nbsp;<div className="d-none d-md-flex d-sm-flex">some</div>
          &nbsp;help?
        </div>
      </div>
      <ConfirmModal
        show={show}
        title="Let us give you a call"
        text="If you're struggling to shop on our website, one of our friendly consultants can call you and assist over the phone."
        cancelLabel={cancelLabel}
        confirmLabel={confirmLabel}
        imageUrl={`${imagePrefix}/assets/images/consultant.svg`}
        handleCancel={handleDismiss}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

GetHelp.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  leadBucket: PropTypes.string,
  stacked: PropTypes.bool,
};

export default GetHelp;
